import { createContext } from 'react';

export const ModalsContext = createContext({});
export const CollectionsContext = createContext({});
